import { request } from "graphql-request";

import { GRAPHQL_PRIVATE_API } from "../../constants/Vention";
import {
  GET_PROJECTS_QUERY,
  GetProjectsCollectionDTO,
  GetProjectsParams,
} from "./queries/project.queries";
import {
  GET_CURRENT_USER_QUERY,
  GetCurrentUserDTO,
  GetCurrentUserQueryParams,
} from "./queries/project-users.queries";
import { ID, SortDirection } from "../Types";
import {
  GET_PARTS_FOR_PROJECT_QUERY,
  GetPartsForProjectQueryParams,
  GetPartsForProjectCollectionDTO,
  SaveProjectPartMutationDTO,
  SaveProjectPartMutationParams,
  SAVE_PROJECT_PART_MUTATION,
} from "./queries/project-parts.queries";
import {
  ProjectFilterCreatedBy,
  ProjectFilterStatus,
  ProjectSortBy,
} from "./Types";

export const ProjectService = {
  queryCurrentUser: async () => {
    return request<GetCurrentUserDTO, GetCurrentUserQueryParams>(
      GRAPHQL_PRIVATE_API,
      GET_CURRENT_USER_QUERY,
    );
  },
  queryProjects: async (
    page: number,
    perPage: number,
    sortBy: ProjectSortBy,
    sortDirection: SortDirection,
    search: string | null,
    dateFrom: Date | null,
    dateTo: Date | null,
    status: ProjectFilterStatus | null,
    predefinedFilter: ProjectFilterCreatedBy | null,
  ): Promise<GetProjectsCollectionDTO> => {
    const predefinedFilterValue =
      predefinedFilter === "All" || !predefinedFilter
        ? null
        : predefinedFilter === "Me"
          ? "my_projects"
          : "editor_access";
    return request<GetProjectsCollectionDTO, GetProjectsParams>(
      GRAPHQL_PRIVATE_API,
      GET_PROJECTS_QUERY,
      {
        page,
        pageSize: perPage,
        sortBy,
        sortDirection,
        search,
        createdAtFrom: dateFrom?.toISOString() ?? null,
        createdAtTo: dateTo?.toISOString() ?? null,
        archived: status === "Archived",
        predefinedFilter: predefinedFilterValue,
      },
    );
  },

  // it is used
  queryPartsForProject: async (
    page: number,
    perPage: number,
    projectId: ID,
  ): Promise<GetPartsForProjectCollectionDTO> => {
    return request<
      GetPartsForProjectCollectionDTO,
      GetPartsForProjectQueryParams
    >(GRAPHQL_PRIVATE_API, GET_PARTS_FOR_PROJECT_QUERY, {
      projectId,
      page,
      pageSize: perPage,
    });
  },
  mutateSaveProjectPart: async (
    projectId: ID,
    partId: ID,
    quantity: number,
  ): Promise<SaveProjectPartMutationDTO> => {
    return request<SaveProjectPartMutationDTO, SaveProjectPartMutationParams>(
      GRAPHQL_PRIVATE_API,
      SAVE_PROJECT_PART_MUTATION,
      {
        projectId,
        partId,
        quantity,
      },
    );
  },
};
